import React from 'react';
import SpotlightCarousel from './SpotlightCarousel';

const HeroSection = ({ mode = 'all' }) => {
  return (
    <section className="py-[32px] md:py-[60px]">
      <div className="w-full lg:px-[120px] md:px-[60px] px-[16px]">
        <SpotlightCarousel mode={mode} />
      </div>
    </section>
  );
};

export default HeroSection;